/**
 * Copyright © 2014 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 10.07.2014, 19:11
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { BasicConstants } from "../../constants/BasicConstants";
import { LiveEnvironment } from "./LiveEnvironment";

/**
 * Represents the live or production environment of the client
 */
export class LiveTestEnvironment extends LiveEnvironment {
    public static LIVE_TEST_ENVIRONMENT_ID: string = "LiveTestEnvironment";

    constructor() {
        super(LiveTestEnvironment.LIVE_TEST_ENVIRONMENT_ID);
    }

    public initPatterns(): void {
        super.initPatterns();

        if (!this._data.globals.urlVariables.forceToShowTestServers) {
            this._networkConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/games-config-test/network/{gameId}/{networkVersion}/{networkId}.xml";
        }

        this._countryConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/games-config-test/country/{gameId}/{countryVersion}/country.xml";
        this._languageConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/games-config-test/language/{gameId}/{languageVersion}/{languageCode}.{zipSuffix}";

        this._cldrConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/games-config-test/language/{gameId}/cldr";

        this._versionPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/games-config-test/version/{gameId}/version.json";

        this._branchesConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/branches-livetest/{gameFileName}/branches.xml";
        this._gameUrlPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/branches-livetest/{gameFileName}/{branchId}/{gameTitle}Game_{branchVersion}.swf";
    }

    public isSupported(): boolean {
        return this._data.globals.isLiveTest;
    }
}
